const listViewStrings = {
    emptyString: '',
    highImportanceMessage: 'High',
    meetingRequestClass: 'IPM.Schedule.Meeting.Request',
};

export default listViewStrings;
